interface SEOJsonLdProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SEOJsonLd({ type, data }: SEOJsonLdProps) {
  const schema = { '@context': 'https://schema.org', '@type': type, ...data };
  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}